<form class="form-benevole" [formGroup]="form" (ngSubmit)="onSubmit()">
  @for (field of fields; track $index) {
    @if (field.type === 'group' && field.children?.length) {
      <div class="coordinates-fields">
        @for (subField of field.children; track $index) {
          <div class="form-field">
            <app-input-field [fieldConfig]="subField" [formGroup]="form" />
            <app-input-field-error [control]="form.get(subField.name)" [fieldName]="subField.name" />
          </div>
        }
      </div>
    } @else {
      <div class="form-field">
        <app-input-field [fieldConfig]="field" [showPasswordRules]="field.showPasswordRules || false" [formGroup]="form" dateMode="past" />
        <app-input-field-error
          [control]="form.get(field.name)"
          [fieldName]="field.name"
          [showPasswordMismatchError]="
            field.name === 'confirmPassword' && form.errors?.['passwordsMismatch'] && form.get('confirmPassword')?.touched
          " />
      </div>
    }
  }

  <div class="legal-section">
    <div class="checkbox-container">
      <input type="checkbox" id="cguConsent" formControlName="cguConsent" />
      <label for="cguConsent">
        J’accepte les
        <a href="/cgu" target="_blank">Conditions Générales d’Utilisation</a>.
      </label>
    </div>

    <div class="checkbox-container">
      <input type="checkbox" id="rgpdConsent" formControlName="rgpdConsent" />
      <label for="rgpdConsent">
        J’accepte le traitement de mes données personnelles conformément à la
        <a href="/politique-confidentialite" target="_blank">Politique de Confidentialité</a>.
      </label>
    </div>
  </div>

  <div class="submit-button">
    <button pButton type="submit" class="register-btn" [disabled]="form.invalid">S'enregistrer</button>
  </div>
</form>
